export const GET_CONTACTS = 'GET_CONTACTS' ;
export const GET_EVENTS = 'GET_EVENTS' ;
export const SELECT_EVENT = 'SELECT_EVENT' ;
export const SELECT_TRACK = 'SELECT_TRACK' ;
export const SELECT_EVENTCLASS = 'SELECT_EVENTCLASS' ;
export const SELECT_COMPETITOR = 'SELECT_COMPETITOR' ;
export const DESELECT_COMPETITOR = 'DESELECT_COMPETITOR' ;
export const SWITCH_EVENT_SOURCE = 'SWITCH_EVENT_SOURCE' ;
export const DESELECT_EVENT = 'DESELECT_EVENT' ;
export const DESELECT_EVENTCLASS = 'DESELECT_EVENTCLASS' ;
export const DESELECT_TRACK = 'DESELECT_TRACK' ;
export const NEXT_EVENTCLASS = 'NEXT_EVENTCLASS' ;
export const PREV_EVENTCLASS = 'PREV_EVENTCLASS' ;
export const EVENT_UPDATED = 'EVENT_UPDATED' ;
export const INIT_UI = 'INIT_UI' ;
export const NEXT_SELECTOR = 'NEXT_SELECTOR' ;
export const PREV_SELECTOR = 'PREV_SELECTOR' ;
export const SHOW_SELECTOR = 'SHOW_SELECTOR' ;
export const CLOSE_SELECTOR = 'CLOSE_SELECTOR' ;
export const SELECT_ITEM = 'SELECT_ITEM' ;
export const GOT_TIMESTAMP = 'GOT_TIMESTAMP' ;
